import {FC, MouseEvent, useState} from 'react'
import {approveOffers, getOffers} from "../../wordpress/operations/get-offers";
import {campaigns} from "../../constants/global";

interface Props {
    booking: Booking
    setBooking: Function
}

const Offers: FC<Props> = ({booking, setBooking }) => {

    const closeTooltip = (event: MouseEvent) => {
        event.currentTarget.parentElement.classList.add("wco-info-tooltip--hidden")
        event.preventDefault()
        event.stopPropagation()
    }

    const openTooltip = (event: MouseEvent) => {
        const collection = document.getElementsByClassName("wco-info-tooltip--hidden");
        for (let i = 0; i < collection.length; i++) {
            collection[i].classList.remove("wco-info-tooltip--hidden");
        }
        event.preventDefault()
        event.stopPropagation()
    }

    const [offers, setOffers] = useState<any>(null);
    const [discounts, setDiscounts] = useState<any>([]);
    if(!offers) {
        getOffers(booking).then((val) => {
            console.log('offers', val)
            setOffers(val.offers)
            setDiscounts(val.discounts)
            campaigns.offers = val.offers
        })
        return
    }

    console.log('discounts', discounts)
    const approvedOffers = approveOffers(booking, offers)

    return (
        <div className="wco-campaigns">
            <div className="wco-campaign mb-4" id="wco-campaign" data-campaign="">
                <h2>Personliga erbjudanden</h2>
                <ul>
                    {approvedOffers.map((offer: any, i: number) => (
                        <li key={i} className={`offer${offer.active ? " active" : ""}`}>
                            <div className={"campaign__marker"}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path
                                        d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                </svg>
                            </div>

                            <div className={"campaign__content"}>
                                <h3 className={"campaign__header"}>{offer.header}</h3>
                                <div className="expire">Giltighetstid: {offer.expire}</div>
                            </div>

                            <div className="wco-info" onMouseDown={(event) => openTooltip(event)}>
                                <i className="far fa-info-circle" aria-hidden="true"/>
                                <div className="wco-info-tooltip">
                                    <div className="wco-info-tooltip__close"
                                         onMouseDown={(event) => closeTooltip(event)}>
                                        <i className="popup_close far fa-times-circle" aria-hidden="true"></i>
                                    </div>
                                    <div dangerouslySetInnerHTML={{__html: offer.description}}/>
                                </div>
                            </div>
                            {offer.active}
                        </li>
                    ))}
                </ul>
                {!booking.workshop && (
                    <span className="note">Komplett lista med erbjudanden visas efter val av verkstad.</span>
                )}
            </div>

            {discounts && discounts.length > 0 && discounts[0].last_minute_booking && (
                <div className="wco-campaign" id="wco-campaign" data-campaign="">
                    <h2>Sista minuten erbjudande</h2>
                    <div className={"campaign__content"}>
                        <h3 className={"campaign__header"}>{discounts[0].name}</h3>
                        <div className="description mb-1">{discounts[0].service} - {discounts[0].center}</div>
                        <div className="description mb-1">Bilmärke: {discounts[0].car}</div>
                        <div className="description">För bokat datum: <strong>{discounts[0].date}</strong></div>
                    </div>
                </div>
            )}

            {discounts && discounts.length > 0 && !discounts[0].last_minute_booking && (
                <div className="wco-campaign" id="wco-campaign" data-campaign="">
                    <h2>Rabattkod</h2>
                    <ul>
                        {discounts.map((discount: any, i: number) => (
                            <div key={i} className={"campaign__content"}>
                                <h3 className={"campaign__header"}>{discount.code}</h3>
                                <div className="expire">Giltighetstid:</div>
                            </div>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    )
}

export default Offers
